import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'calendarOptions' })
export class CalendarOptionsPipe implements PipeTransform {
  transform(arr: any[]): any[] {
    if (!arr || !Array.isArray(arr)) return [];
    return arr.map(item => ({ value: item, label: item.name }));
  }
}